import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewEncapsulation } from '@angular/core'
import { NgElement, WithProperties } from '@angular/elements'
import { registerCustomElementFactory } from '../../custom-elements/register-custom-element-factory'
import { SelectorBasedSlotDirective } from '../../directives'

/**
 * @public
 */
export type CardElement = NgElement & WithProperties<CardComponent>

/**
 * @public
 */
@Component({
  selector: 'gpei-card',
  templateUrl: './card.component.html',
  styleUrls: [ './card.component.sass' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: true,
  imports: [
    SelectorBasedSlotDirective
  ],
  schemas: [
    NO_ERRORS_SCHEMA
  ]
})
export class CardComponent {}

/**
 * @public
 */
export const registerCardElement = registerCustomElementFactory(CardComponent)
